import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '../utils.class';

@Pipe({
    name: 'isDateBefore'
})
export class IsDateBeforePipe implements PipeTransform {

    transform(date: Date, beforeDate?: Date): unknown {
        if (!beforeDate) {
            beforeDate = new Date();
        }
        return Utils.getDateGetTime(date) < Utils.getDateGetTime(beforeDate);
    }

}
